import React from 'react';
import { Box, useMediaQuery } from '@mui/material';
import HeroImage from '../../assets/images/AboutUsIntroPic.png';
import theme from '../../theme';

function UserHeroSectionComponents() {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box>
      {!isMobile ? (
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: "auto",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src={HeroImage}
            loading='eager'
            alt="heroimage"
            style={{
              width: "50%",
              height: "auto",
              maxHeight: isMobile ? "none" : "50vh",
              objectFit: "contain",
            }}
          />
        </Box>
      ) : (
        // <Box
        //   sx={{
        //     position: 'relative',
        //     width: '100%',
        //     maxWidth: '600px',
        //     margin: 'auto',
        //     overflow: 'hidden',  // Hide overflowing content
        //   }}
        // >
        //   <Box
        //     sx={{
        //       display: 'flex',
        //       transition: 'transform 0.5s ease-in-out',
        //       transform: `translateX(-${currentIndex * 100}%)`, // Move the image list left/right
        //     }}
        //   >
        //     {/* Map through images and display them in a row */}
        //     {images.map((img, index) => (
        //       <img
        //         key={index}
        //         src={img}
        //         alt={`carousel-${index}`}
        //         style={{
        //           width: '100%',  // Ensure each image takes the full width of the container
        //           height: 'auto',
        //         }}
        //       />
        //     ))}
        //   </Box>

        //   {/* Next button */}
        //   <IconButton
        //     onClick={handleNext}
        //     sx={{
        //       position: 'absolute',
        //       top: '50%',
        //       right: 10,
        //       transform: 'translateY(-50%)',
        //       backgroundColor: 'rgba(0, 0, 0, 0.5)',
        //       color: 'white',
        //       '&:hover': {
        //         backgroundColor: 'rgba(0, 0, 0, 0.7)',
        //       },
        //     }}
        //   >
        //   </IconButton>

        //   {/* Prev button */}
        //   <IconButton
        //     onClick={handlePrev}
        //     sx={{
        //       position: 'absolute',
        //       top: '50%',
        //       left: 10,
        //       transform: 'translateY(-50%)',
        //       backgroundColor: 'rgba(0, 0, 0, 0.5)',
        //       color: 'white',
        //       '&:hover': {
        //         backgroundColor: 'rgba(0, 0, 0, 0.7)',
        //       },
        //     }}
        //   >
        //   </IconButton>
        // </Box>
        <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "auto",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          src={HeroImage}
          alt="heroimage"
          style={{
            width: "100%",
            height: "auto",
            maxHeight: isMobile ? "none" : "70vh",
            objectFit: "contain",
          }}
        />
      </Box>
      )
      }
    </Box>
  );
}

export default UserHeroSectionComponents;
